import { Modal } from 'antd';
import React, { ReactNode } from 'react';
import HSButton from '../../../../../common/Button';

type Props = {
    title: string;
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
    centered?: boolean;
    className?: string;
    confirmationLoading?: boolean;
    children: ReactNode;
    showCancel?: boolean;
    confirmButtonTitle?: string;
    cancelButtonTitle?: string;
};

const TeamManagementModal: React.FC<Props> = ({
    title,
    open,
    onOk,
    onCancel,
    centered = false,
    className = '',
    confirmationLoading = false,
    children,
    showCancel = false,
    confirmButtonTitle = '',
    cancelButtonTitle = '',
}) => {
    return (
        <Modal
            title={title}
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            footer={
                <div className="p-2 flex justify-start items-center">
                    {showCancel ? (
                        <HSButton
                            title={cancelButtonTitle || 'No'}
                            onClick={onCancel}
                            className="onboarding_btn_modal_close setting_btn_modal"
                        />
                    ) : null}
                    <HSButton
                        title={confirmButtonTitle || 'Yes'}
                        className="ml-4 WorkSans setting_btn_modal"
                        onClick={onOk}
                        loading={confirmationLoading}
                    />
                </div>
            }
            centered={centered}
            className={`onboarding_NDA_POP ${className}`}
        >
            {children}
        </Modal>
    );
};

export default TeamManagementModal;
